import React, { useEffect, useRef, useState } from "react";
import { initiateKyc, updatingKycDetails } from '../../actions/auth';

import actionIcon from "../../assets/img/icon/kyc-icon.png";

import './toDo.css';
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Vove, { VoveEnvironment } from "@vove-id/web-sdk";
import FormModal from "../FormModal";
import { initiateKycFlow } from "../../actions/user";
import { setUser } from "../../redux/slices/userSlice";
import { Modal } from "bootstrap";
import { useNavigate } from "react-router-dom";

const Kyc = ({ userDetails }) => {
  const navigate = useNavigate();
  const [kycStatus, setKycStatus] = useState(userDetails?.kyc_profile?.status);
  const [kycVerifiedAt, setKycVerifiedAt] = useState(userDetails?.kyc_profile?.last_verified_at);
  const isKycDisabled = ["pending", "processing", "in_review", "approved"].includes(kycStatus) || kycVerifiedAt;
  return (
    <>
      <section className="toDoList-card rounded-2 ">
        <div className="toDo-container">
          <div className="toDo-icon">
            <img src={actionIcon} alt="KYC Verification" className="img-fluid" />
          </div>
          <div className="toDo-text">
            <h4>KYC Verification</h4>
            <p>Kindly verify your identity to access all services</p>
          </div>
          {userDetails?.account_type == 'personal' ? <button 
            className="toDo-button"
            disabled={isKycDisabled}
            data-bs-toggle="modal"
            data-bs-target="#kycModal"
          >
            {kycStatus === "pending" ? "Pending..."
              : kycStatus === "processing" ? 'Processing...'
              : kycStatus === "verified" || kycVerifiedAt ? "Verified" 
              : "Verify Now"}
          </button> : <button 
            className="toDo-button"
            onClick={() => {
              navigate("/user/settings", { state: { activeTab: 'compliance'} });
            }}
          > Verify Now </button>}
        </div>
      </section>
    </>
  );
};

export default Kyc;